import { benefits } from "../constants";

import Section from "./Section";
import TagLine from "./Tagline";
import { brainwaveServices } from "../constants";
import { interview1 } from "../assets";
import Arrow from "../assets/svg/Arrow";

const Benefits = () => {
  return (
    <Section>
      <div className="container">
        <div
          className={`relative z-2 mx-auto mb-12 max-w-[50rem] text-center md:text-center lg:mb-20`}
        >
          <h3
            className={`h7 h2 mb-3 transform !text-4xl uppercase text-[#B780EF] transition-all hover:scale-105 2xl:text-6xl`}
          >
            AI MOCK INTERVIEW
          </h3>

          <TagLine
            className={`mb-4 justify-center text-center !text-sm md:text-nowrap 2xl:text-base`}
          >
            Ace Every Interview with AMY — Your Ultimate AI Interview Coach!
          </TagLine>
        </div>

        <div className="mx-auto flex max-w-[45rem] flex-col gap-12 rounded-xl bg-neutral-950 neon-purple xl:max-w-[77rem] xl:flex-row">
          {/* Left Column: Image/Visual */}
          <div className="xl:w-1/2">
            <img
              src={interview1}
              alt="AI Mock Interview"
              className="rounded-t-xl opacity-90 md:aspect-[16/11] lg:h-full lg:w-full xl:aspect-auto xl:rounded-s-xl xl:rounded-t-none xl:object-cover"
            />
          </div>

          {/* Right Column: Content */}
          <div className="w-full px-4 py-4 xl:w-1/2 xl:py-8 xl:pl-0">
            <h4 className="h7 text-center text-2xl font-bold text-white sm:text-3xl lg:text-4xl">
              Ace Every Interview with <br />
              <span className="text-[#B780EF]">AI-Powered Precision</span>
            </h4>
            <TagLine className="mt-4 flex justify-center text-center">
              Stand Out. Speak Confidently. Get Hired.
            </TagLine>
            <p className="mt-6 text-left text-sm leading-loose text-n-2 sm:text-base">
              Streamline your recruitment process with our AI Mock Interview
              Agent. Providing realistic, tailored interview simulations, it
              helps candidates prepare effectively with real-time feedback and
              industry-specific questions. This sophisticated tool enhances
              interview readiness, ensuring candidates are equipped with the
              skills and confidence to excel.
            </p>
            <div className="mt-6 flex flex-col space-y-4">
              {brainwaveServices.map((item, index) => (
                <span className="text-left text-sm text-n-2" key={index}>
                  {`➤ ${item}`}
                </span>
              ))}
            </div>
            <div className="mt-12 flex justify-center gap-4 xl:justify-start">
              <a href="https://www.themockinterview.com">
                <button className="rounded-lg bg-neutral-900 px-6 py-3 font-medium text-white shadow-md hover:bg-neutral-800">
                  Explore More
                </button>
              </a>
            </div>
          </div>
        </div>

        <div className="mb-10 mt-12 grid grid-cols-1 gap-10 min-[720px]:grid-cols-2 min-[1100px]:grid-cols-3">
          {benefits.map((item) => (
            <div
              className="grid-col-2 relative mx-auto grid w-full rounded-xl neon-purple"
              key={item.id}
            >
              <div className="relative z-2 flex flex-col p-[2.1rem]">
                <p className="mb-5 text-lg font-semibold">{item.title}</p>
                <p className="body-2 mb-6 text-n-2">{item.text}</p>
                <div className="mt-auto flex items-center justify-between">
                  <img
                    src={item.iconUrl}
                    width={50}
                    height={50}
                    alt={item.title}
                  />
                  <a
                    href="https://www.themockinterview.com"
                    className="flex cursor-pointer items-center"
                  >
                    <p className="ml-auto font-code text-sm font-bold uppercase tracking-wider text-n-1">
                      Explore more
                    </p>
                    <Arrow />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
};

export default Benefits;
